import { useEffect, useState } from "react";
import api from "./api";

const FALLBACK = { monthly_regular_cents: 1999, monthly_cents: 1999, yearly_cents: 20000, launch_active: false, launch_ends_at: null, promo_codes_available: true, monthly_promo_codes_available: true };
let cache = null;
let inflight = null;
const listeners = new Set();

export const usd = (cents) => `$${(cents / 100).toFixed(2).replace(/\.00$/, "")}`;

// Always hits the server (the server clock decides whether the launch price applies) and pushes the result to every mounted price.
export function refreshPricingOffer() {
  inflight = inflight || api.get("/pricing/offer").then((r) => { cache = r.data; listeners.forEach((fn) => fn(cache)); return cache; })
    .catch(() => cache || FALLBACK).finally(() => { inflight = null; });
  return inflight;
}

// Server-decided pricing (the checkout uses the same rule): $19.99/mo normally, $15/mo while the launch offer is active.
// Revalidates when the tab regains focus so a page left open across the deadline doesn't keep promising $15.
export function usePricingOffer() {
  const [offer, setOffer] = useState(cache || FALLBACK);
  useEffect(() => {
    listeners.add(setOffer);
    if (cache) setOffer(cache);
    refreshPricingOffer();
    const onFocus = () => { if (document.visibilityState === "visible") refreshPricingOffer(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => { listeners.delete(setOffer); window.removeEventListener("focus", onFocus); document.removeEventListener("visibilitychange", onFocus); };
  }, []);
  return offer;
}

// "$19.99/mo" or "$15/mo" (with the regular price struck through) for upgrade buttons and CTAs.
export function MonthlyPrice({ className = "", suffix = "/mo" }) {
  const o = usePricingOffer();
  if (!o.launch_active) return <span className={className} data-testid="monthly-price">{usd(o.monthly_regular_cents)}{suffix}</span>;
  return (
    <span className={className} data-testid="monthly-price">
      <span className="sr-only">Regular price </span><s className="opacity-60 font-normal mr-1" data-testid="monthly-price-regular">{usd(o.monthly_regular_cents)}</s><span className="sr-only"> launch price </span>{usd(o.monthly_cents)}{suffix}
    </span>
  );
}
